import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { AppI18n } from '../../../i18n';

interface HighlightContainerProps {
  variant: 'info' | 'neutral';
  children: React.ReactNode;
}

export const HighlightContainer = ({ variant = 'info', children }: HighlightContainerProps) => (
  <Container
    backgroundColor={variant === 'info' ? 'blue_100' : 'grey_200'}
    borderRadius="md"
    paddingX="2.5"
    paddingY="1.5"
    maxWidth="fit-content"
  >
    <Typography fontWeight="bold" color={variant === 'info' ? 'blue_1100' : 'bodyPrimary'} size="b_sm">
      {children}
    </Typography>
  </Container>
);

export const AuctionFlowHighlight = () => (
  <HighlightContainer variant="info">
    <AppI18n k="routing.auction_highlight" />
  </HighlightContainer>
);

export const InviteFlowHighlight = () => (
  <HighlightContainer variant="neutral">
    <AppI18n k="routing.invite_highlight" />
  </HighlightContainer>
);
